import Block from '@/components/Block';
import { Image } from '@bfe/moly';
import { useFm, useScreenType } from '@web3/base-hooks';
import { publicAssetsPath } from '@web3/base-utils';
import styles from './style.module.scss';
import clsx from 'clsx';
import { RedeemedInfo } from './RedeemedInfo';
import { LotterySection } from './LotterySection';

export const CanDo = () => {
  return (
    <Block className="mt-14">
      <RedeemedInfo className="mb-10" />
      <LotterySection />
      <PointsIntroduction />
    </Block>
  );
};

const PointsIntroduction = () => {
  const { isMobile } = useScreenType();
  const fm = useFm();

  return (
    <Block
      title={fm('whatRewardsCanYouGet')}
      className={clsx([
        styles['can-do-wrap'],
        isMobile ? 'mt-10 px-6' : 'mt-12',
      ])}
      titleClass="!text-2xl"
    >
      <div
        className={clsx(
          ' grid',
          isMobile ? 'grid-cols-1 mt-8 gap-6' : 'grid-cols-3 mt-12 gap-8'
        )}
      >
        <div
          className={clsx([
            styles['can-do-item'],
            isMobile && styles['can-do-item-h5'],
          ])}
        >
          <div className="relative w-[174px] h-[174px] flex items-center justify-center">
            <Image
              className="w-[174px] h-[174px]"
              src={publicAssetsPath('/png/upcoming/halo.png')}
              alt="halo"
            />
            <Image
              className="absolute w-[88px] h-[88px]"
              src={publicAssetsPath('/png/upcoming/MNT.png')}
              alt="MNT"
            />
          </div>
          <div className="pl-5">
            <h2
              className={clsx(
                styles['reward-count'],
                'font-semibold text-[36px] pt-3'
              )}
            >
              MNT 2~100
            </h2>
            <h3 className="medium-24 pt-5">MNT Airdrops</h3>
          </div>
        </div>
        <div className={clsx([styles['can-do-item'], 'bg-card relative'])}>
          <div className="relative w-[174px] h-[174px] flex items-center justify-center">
            <Image
              className="w-[174px] h-[174px]"
              src={publicAssetsPath('/png/upcoming/halo.png')}
              alt="halo"
            />
            <Image
              className="absolute w-[88px] h-[88px]"
              src={publicAssetsPath('/png/upcoming/PENGU.png')}
              alt="PENGU"
            />
          </div>
          <div className="pl-5">
            <h2
              className={clsx(
                styles['reward-count'],
                'font-semibold text-[36px] pt-3'
              )}
            >
              PENGU 200~10000
            </h2>
            <h3 className="medium-24 pt-5">PENGU Airdrops</h3>
          </div>
        </div>
        <div className={clsx([styles['can-do-item'], 'bg-card relative'])}>
          <Image
            className="w-[174px] h-[174px]"
            src={publicAssetsPath('/png/upcoming/parachute.png')}
            alt="parachute"
          />
          <div className="pl-5 pb-9">
            <h2
              className={clsx(
                'text-[#595D61]',
                'font-semibold',
                isMobile ? 'text-3hxl' : 'text-[36px]'
              )}
            >
              {fm('next')}
            </h2>
            <p className="regular-24 text-[#595D61] mt-3">
              {fm('updateRewardsGradual')}
            </p>
          </div>
        </div>
      </div>
    </Block>
  );
};
